/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation LBRRoutePlanUpdateMutation($routePlanId: ID, $routePlanIds: [ID!], $input: [LBRRoutePlanUpdateInput!]!) {
  LBRRoutePlanUpdate(routePlanId: $routePlanId, routePlanIds: $routePlanIds, input: $input) {
    id,
    message
    status
  }
}
`
